import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { isWeb } from '../../constants';
const StackHeader = ({ title, color }) => (<View style={styles.container}>
    <Text Text-18 centered numberOfLines={1} ellipsizeMode="tail" style={styles.text} {...(color && { color })}>
      {title}
    </Text>
  </View>);
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        overflow: isWeb ? 'hidden' : 'scroll',
        maxWidth: isWeb ? 600 : 250,
        flexShrink: 1,
    },
    text: {
        flexShrink: 1,
        paddingHorizontal: rem(8),
    },
});
export default memo(StackHeader);
